import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import App from './search-app/App'
import rootReducer from './search-app/reducers'
import { initStore } from './search-app/store'

const componentRoot = document.getElementById( 'search-app' )

if ( componentRoot ) {
  const initialState = JSON.parse( window.atob( componentRoot.dataset.state ))
  const store = initStore( rootReducer, initialState )

  render(
    <Provider store={store}>
      <App />
    </Provider>,
    componentRoot
  )
}
